import { createFileRoute } from "@tanstack/react-router"

import { PortalHomeView } from "@/features/portal/components/portal-home-view"

export const Route = createFileRoute("/_shell/home/")({
  component: PortalHomeView,
})
